import * as React from 'react';
import RouteCalculator from './components/RouteCalculator';
import CustomerForm from './components/CustomerForm';
import * as API from '../../../api/laas-api';
import LaasFaq from './LaasFaq';
import { ShippingRouteApiResponse } from '../../../api/types/shipping-route';
import { ShippingCustomer } from '../../../api/types/shipping-customer';
import { ShippingEmailApiBody } from '../../../api/types/shipping-email';

interface defaultState {
    route: ShippingRouteApiResponse;
    customer: ShippingCustomer;
    showLead: boolean;
    showConfirmation: boolean;
    showError: boolean;
    resetCalc: boolean;
}

class laasLeadForm extends React.Component<any, defaultState> {
    constructor(props: any) {
        super(props);
        this.state = {
            route: {
                sourceStoreID: '',
                sourceStoreState: '',
                sourceStoreName: '',
                destinationStoreID: '',
                destinationStoreState: '',
                destinationStoreName: '',
                miles: '',
                basePrice: '',
                totalPrice: '',
                azSalesTax: '',
            },
            customer: {
                name: '',
                phone: '',
                email: '',
                vehicleYear: '',
                vehicleMake: '',
                vehicleModel: '',
                dropOffDate: '',
            },
            showLead: false,
            showConfirmation: false,
            showError: false,
            resetCalc: false,
        };
        this.handleSubmitRoute = this.handleSubmitRoute.bind(this);
        this.handleSubmitCustomerInfo = this.handleSubmitCustomerInfo.bind(this);
    }
    private async handleEmailRequest() {
        const email: ShippingEmailApiBody = {
            name: this.state.customer.name,
            phone: this.state.customer.phone,
            email: this.state.customer.email,
            route: this.state.route,
            vehicleYear: this.state.customer.vehicleYear,
            vehicleMake: this.state.customer.vehicleMake,
            vehicleModel: this.state.customer.vehicleModel,
            dropOffDate: this.state.customer.dropOffDate,
        };

        const emailSent: boolean = await API.postShippingOrder(email);

        if (emailSent) {
            this.setState({
                showConfirmation: true,
                showError: false,
            });
        } else {
            this.setState({
                showConfirmation: false,
                showError: true,
            });
        }
    }
    private handleSubmitRoute(shippingRoute: ShippingRouteApiResponse) {
        this.setState({
            route: shippingRoute,
            showLead: true,
            showConfirmation: false,
            showError: false,
        });
    }
    private handleSubmitCustomerInfo(customerData: ShippingCustomer) {
        this.setState(
            {
                customer: customerData,
                showLead: false,
                resetCalc: !this.state.resetCalc,
            },
            this.handleEmailRequest
        );
    }
    public render(): React.ReactNode {
        const headlineText = "Moving? We'll ship your car";
        const sublineText = 'CarMax can give you an instant quote';
        const routeCalcPosition = this.state.showConfirmation && !this.state.showLead ? ' absolute' : '';
        return (
            <section className="laas-app">
                <section id="laas-lead-form" className="laas-lead-form">
                    <div className="laas-hero-banner">
                        <div className="laas-hero-banner-content">
                            <h1 className="laas-hero-banner-main">{headlineText}</h1>
                            <h2 className="laas-hero-banner-sub">{sublineText}</h2>
                        </div>
                    </div>
                    <div className={'laas-route-calculator-container' + routeCalcPosition}>
                        {this.state.resetCalc ? (
                            <RouteCalculator key={'1'} handleSubmitRoute={this.handleSubmitRoute} />
                        ) : (
                            <RouteCalculator key={'2'} handleSubmitRoute={this.handleSubmitRoute} />
                        )}
                    </div>
                    {this.state.showLead && <CustomerForm handleSubmitCustomerInfo={this.handleSubmitCustomerInfo} />}
                    {this.state.showConfirmation && (
                        <div id="laas-lead-form-confirmation" className="laas-lead-form-confirmation">
                            <div className="laas-lead-form-confirmation-content">
                                <h2 className="laas-lead-form-confirmation--headline">
                                    {this.state.customer.name}, your car is about to get a lift!
                                </h2>
                                <div className="laas-lead-form-confirmation--subline">
                                    Thanks for your information. One of our consultants will be in touch, however feel
                                    free to reach out as well!
                                </div>
                            </div>
                        </div>
                    )}
                    {this.state.showError && (
                        <div id="laas-lead-form-error" className="laas-lead-form-error">
                            <div className="laas-lead-form-error-content">
                                <h2 className="laas-lead-form-error--headline">
                                    Hmm… a wrench got thrown in the works on
                                    <br />
                                    our end, please submit your order again
                                </h2>
                                <div className="laas-lead-form-error--subline">
                                    Please try re-submitting your information, or feel free to get in touch. Our contact
                                    information is below.
                                </div>
                            </div>
                        </div>
                    )}
                </section>
                {!this.state.showConfirmation && (
                    <section id="laas-how-it-works" className="laas-how-it-works">
                        <h2 className="laas-how-it-works-header">How does my auto transport work?</h2>
                        <div className="laas-how-it-works-content">
                            <div className="laas-how-it-works-block">
                                <img
                                    className="laas-how-it-works-icon"
                                    src="/home/images/laas/find_a_route.svg"
                                    aria-hidden="true"
                                    alt="find a route"
                                />
                                <span className="laas-how-it-works-desc">
                                    Find your route, see your quote, and book the trip
                                </span>
                            </div>
                            <div className="laas-how-it-works-block">
                                <img
                                    className="laas-how-it-works-icon"
                                    src="/home/images/laas/drop_off_car.svg"
                                    aria-hidden="true"
                                    alt="drop off car"
                                />
                                <span className="laas-how-it-works-desc">
                                    Drop off your vehicle at a participating CarMax
                                </span>
                            </div>
                            <div className="laas-how-it-works-block">
                                <img
                                    className="laas-how-it-works-icon"
                                    src="/home/images/laas/pick_up.svg"
                                    aria-hidden="true"
                                    alt="pick up"
                                />
                                <span className="laas-how-it-works-desc">Stress-free pick up on the other side</span>
                            </div>
                        </div>
                    </section>
                )}
                <LaasFaq />
            </section>
        );
    }
}

export default laasLeadForm;
